/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { ContactGroupResponse } from '../models/contact-group-response';
import { CreateContactGroupRequest } from '../models/create-contact-group-request';
import { GenericResponse } from '../models/generic-response';
import { GetContactGroupResponse } from '../models/get-contact-group-response';
import { UpdateContactGroupRequest } from '../models/update-contact-group-request';

/**
 * Contact Group APIs
 */
@Injectable({ providedIn: 'root' })
export class ContactGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllContactGroups()` */
  static readonly GetAllContactGroupsPath = '/api/v1/contact-groups';

  /**
   * Get list of contact group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllContactGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllContactGroups$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - name
       */
      search?: string;

      /**
       * this adds a filter to the following field:
       * - user group
       */
      userGroupId?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetContactGroupResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ContactGroupsService.GetAllContactGroupsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
      rb.query('userGroupId', params.userGroupId, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetContactGroupResponse>;
        })
      );
  }

  /**
   * Get list of contact group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllContactGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllContactGroups(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - name
       */
      search?: string;

      /**
       * this adds a filter to the following field:
       * - user group
       */
      userGroupId?: Array<number>;
    },
    context?: HttpContext
  ): Observable<GetContactGroupResponse> {
    return this.getAllContactGroups$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetContactGroupResponse>
        ): GetContactGroupResponse => r.body
      )
    );
  }

  /** Path part for operation `createContactGroup()` */
  static readonly CreateContactGroupPath = '/api/v1/contact-groups';

  /**
   * Create new contact Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createContactGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContactGroup$Response(
    params: {
      body: CreateContactGroupRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ContactGroupResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ContactGroupsService.CreateContactGroupPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ContactGroupResponse>;
        })
      );
  }

  /**
   * Create new contact Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createContactGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContactGroup(
    params: {
      body: CreateContactGroupRequest;
    },
    context?: HttpContext
  ): Observable<ContactGroupResponse> {
    return this.createContactGroup$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<ContactGroupResponse>): ContactGroupResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `getContactGroupById()` */
  static readonly GetContactGroupByIdPath = '/api/v1/contact-groups/{id}';

  /**
   * Get contact group details using id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactGroupById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactGroupById$Response(
    params: {
      /**
       * The contact group's id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ContactGroupResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ContactGroupsService.GetContactGroupByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ContactGroupResponse>;
        })
      );
  }

  /**
   * Get contact group details using id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContactGroupById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactGroupById(
    params: {
      /**
       * The contact group's id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<ContactGroupResponse> {
    return this.getContactGroupById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<ContactGroupResponse>): ContactGroupResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `disableContactGroup()` */
  static readonly DisableContactGroupPath = '/api/v1/contact-groups/{id}';

  /**
   * disable contact group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableContactGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableContactGroup$Response(
    params: {
      /**
       * The contact group's id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ContactGroupsService.DisableContactGroupPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * disable contact group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disableContactGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableContactGroup(
    params: {
      /**
       * The contact group's id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.disableContactGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateContactGroupById()` */
  static readonly UpdateContactGroupByIdPath = '/api/v1/contact-groups/{id}';

  /**
   * Update contact group by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContactGroupById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContactGroupById$Response(
    params: {
      /**
       * The user group's id that needs to be updated
       */
      id: number;
      body: UpdateContactGroupRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ContactGroupResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ContactGroupsService.UpdateContactGroupByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ContactGroupResponse>;
        })
      );
  }

  /**
   * Update contact group by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateContactGroupById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContactGroupById(
    params: {
      /**
       * The user group's id that needs to be updated
       */
      id: number;
      body: UpdateContactGroupRequest;
    },
    context?: HttpContext
  ): Observable<ContactGroupResponse> {
    return this.updateContactGroupById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<ContactGroupResponse>): ContactGroupResponse =>
          r.body
      )
    );
  }
}
